import { useQuery } from "@tanstack/react-query";
import { sendErrorReport } from "../../../utils/reporting";
import { fetchFlightData } from "v2/api/barcode-leads";
import { BarcodeLeadsFlights } from "../types/intake-funnel";
import { extractBarcodeFlightsData } from "../serializers/intake-funnel";
import { TURNSTILE_COOKIE_NAME } from "../security/TurnstileWidget";
import { Cookies } from "react-cookie";
import { resetTurnstileToken } from "../security/turnstile";

const FIVE_MINUTES = 5 * 60 * 1000;
const cookies = new Cookies();
export function useFetchBarcodeLeadsFlight(flightIdentifiers: any) {
  const turnstileToken = cookies.get(TURNSTILE_COOKIE_NAME);

  const { data, isFetched } = useQuery<BarcodeLeadsFlights | undefined, Error>({
    queryKey: ["flightIdentifier", flightIdentifiers],
    queryFn: async () => {
      if (!flightIdentifiers[0]) {
        return;
      }

      try {
        const rawBarcodeLeadsFlightsData = await fetchFlightData(flightIdentifiers, turnstileToken);

        if (!rawBarcodeLeadsFlightsData) {
          throw new Error("No flights found in barcode leads response");
        }
        const barcodeLeadsData = extractBarcodeFlightsData(rawBarcodeLeadsFlightsData);

        return barcodeLeadsData;
      } catch (error) {
        sendErrorReport(error, "Error on barcode leads flight fetch");
      } finally {
        resetTurnstileToken();
      }
    },
    retry: 2,
    staleTime: FIVE_MINUTES,
  });

  return {
    barcodeLeadsData: data,
    isFetched,
  };
}
